export default __webpack_public_path__ + "static/media/medie_bg_mobile.85d9f6be.png";